import Color from '../Color.mjs'
import extendNode from '../extendNode.mjs'
import superMeta from '../_ATTRIBUTE/metaAttributeNode.mjs'
import useAttributeNode from '../_ATTRIBUTE/useAttributeNode.jsx'

export default () => {
    const AttributeNode = useAttributeNode()

    return extendNode(AttributeNode, {
        ...superMeta,
        prop: 'fmDesc',
        type: 'ATTR_FM_DESC',

        getStyle(map, node) {
            return {
                ...AttributeNode.getStyle.call(this, map, node),
                shape: 'Rectangle',
                backgroundColor: Color.LIGHT_YELLOW,
                borderColor: Color.LIGHT_YELLOW,
            }
        },

        isHidden(map, node) {
            const {mapTypeCode} = map.data
            return '_FA_MAP' !== mapTypeCode
        },
    })
}
